import React, {useEffect} from "react";
import {BasePage} from "@components/page/BasePage";
import UserListTable from "@pages/userManage/UserListTable";
import TableFilter from "@pages/userManage/TableFilter";
import {presentationError} from "@/presentation/errors/presentationError";
import {getMembers} from "@/domain/repository/MemberRepository";
import {useRecoilValue, useSetRecoilState} from "recoil";
import {memberListState, userFilterState} from "@pages/userManage/atoms";


const UserManagePage: React.FC = () => {

    const setMembers = useSetRecoilState(memberListState);
    const filterState = useRecoilValue(userFilterState);
    useEffect(() => {
        getMemberList();
    }, [filterState])

    const getMemberList = async () => {
        try {
            const result = await getMembers(filterState);

            if (result.success && result.response) {
                setMembers(result.response)
            }
        } catch (err) {
            presentationError({
                error: err,
                type: '유저 가져오기',
                alert: true
            });
        }
    }

    return (
        <BasePage title={'회원 관리'}>
            <TableFilter/>
            <UserListTable/>
        </BasePage>
    )
}


export default UserManagePage